import { render, staticRenderFns } from "./SweetAlert.vue?vue&type=template&id=b1c65e1c"
import script from "./SweetAlert.vue?vue&type=script&lang=js"
export * from "./SweetAlert.vue?vue&type=script&lang=js"
import style0 from "./SweetAlert.vue?vue&type=style&index=0&id=b1c65e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports